import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { chatDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'MessageCircle'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.CHAT,
  label: 'ระบบแชท',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE, MODULES.CAR_RENTAL],
  category: 'core',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'แชท',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'จัดการ',
        items: [
          { label: 'กล่องข้อความ', path: '/chat/inbox', icon: 'Inbox' },
        ],
      },
      {
        label: 'ตั้งค่า',
        items: [
          { label: 'ตั้งค่าทั่วไป', path: '/chat/settings', icon: 'Settings' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "conversations", label: "บทสนทนา" },
    { key: "messages", label: "ข้อความ" },
    { key: "settings", label: "ตั้งค่าแชท" },
  ],
  availableHooks: [],

  extendSchemas: {},
  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Catalog First (#644) — metadata-only registry rows consumed by
  // the tenant-worker boot loop. Chat webhooks/routes still own writes.
  registeredDoctypes: chatDoctypes,
})
